/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "UsersIcon",
    menu: "Mahasiswa",
    url: "spi-mahasiswa",
  },
];
